import { render } from "./results.vue?vue&type=template&id=1ff902d2&ts=true"
import script from "./results.ts?vue&type=script&lang=ts"
export * from "./results.ts?vue&type=script&lang=ts"

import "./results.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/codebuild/output/src3439808764/src/codestar-connections.eu-central-1.amazonaws.com/git-http/590183891356/eu-central-1/2cc0c188-c05c-4299-b4b1-a803de2d3cf7/studyportals/PersonalityTestVue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__